import * as React from 'react';
import { imgSrcAttributes } from 'helpers/common';
require('./style.scss');

interface IProps {
	imageData: { x: number; y: number; width: number; height: number };
	imageUrl: string;
	alt: string;
}
export const CroppedImage = ({ imageData, imageUrl, alt }: IProps) => {
	const [originalImageData, setOriginalImageData] = React.useState(null);
	const [imageWrapper, setImageWrapper] = React.useState(null);
	const croppedPhotoRef: React.RefObject<HTMLDivElement> = React.useRef();

	const scaleFactor =
		imageData && imageWrapper
			? {
					x: imageWrapper.width / imageData.width,
					y: imageWrapper.height / imageData.height,
			  }
			: null;

	// Get image size
	React.useEffect(() => {
		const image = new Image();
		image.src = imageUrl;
		image.addEventListener('load', () => {
			setOriginalImageData({ width: image.width, height: image.height });
		});
	}, [imageUrl]);

	const getWrapperSize = () => {
		const wrapperDOM = croppedPhotoRef.current;
		if (wrapperDOM != undefined) {
			setImageWrapper({ width: wrapperDOM?.clientWidth, height: wrapperDOM?.clientHeight });
		}
	};

	React.useEffect(() => {
		getWrapperSize();
	}, [originalImageData, imageData]);

	React.useEffect(() => {
		window.addEventListener('resize', getWrapperSize);

		return () => {
			window.removeEventListener('resize', getWrapperSize);
		};
	});

	const displayCropped = scaleFactor && originalImageData;
	return (
		<>
			{originalImageData && imageData && (
				<div className={`cropped-photo-wrapper`} ref={croppedPhotoRef}>
					{displayCropped && imageWrapper && (
						<img
							className="cropped-photo-container"
							style={{
								width: `${originalImageData.width * scaleFactor.x}px`,
								height: `${originalImageData.height * scaleFactor.y}px`,
								left: `${-imageData.x * scaleFactor.x}px`,
								top: `${-imageData.y * scaleFactor.y}px`,
							}}
							src={imageUrl}
						></img>
					)}
				</div>
			)}
			{!(originalImageData && imageData) && (
				<img {...imgSrcAttributes(imageUrl)} alt={alt} style={{ display: displayCropped ? `none` : `` }} />
			)}
		</>
	);
};
